export default __webpack_public_path__ + "static/media/app-store.059c88e8.svg";